import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';

@Component({
  selector: 'app-confirm-send-back-to-applicant-modal',
  templateUrl: './confirm-send-back-to-applicant-modal.component.html',
  styleUrls: ['./confirm-send-back-to-applicant-modal.component.scss']
})
export class ConfirmSendBackToApplicantModalComponent {

  public data: any;
  endPoint: any;
  payload: any;
  sendBackForm!: FormGroup;
  submitted = false;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private api: SevaProfileService,
    protected dialogRef: NbDialogRef<ConfirmSendBackToApplicantModalComponent>
  ) {
    this.data = this.dialogRef;
  }

  ngOnInit() {
    this.endPoint = this.data.endPoint;
    this.payload = this.data.requestBody;
    this.initializeForm();
  }

  initializeForm() {
    this.sendBackForm = this.fb.group({
      comment: ['', [Validators.required]],
    });
  }

  sendBackToApplicant() {
    if (this.sendBackForm.invalid) {
      this.submitted = true;
      this.sendBackForm.markAllAsTouched();
      return;
    }

    this.submitted = false;
    const comment = this.sendBackForm.get('comment')?.value;
    this.payload.Comment = comment;

    this.api.apiCall(this.endPoint, 'POST', this.payload).subscribe({
      next: (response: any) => {
        if (response.Data) {
          this.toastr.success('Application sent back to applicant successfully');
          this.dialogRef.close(true);
        }
      },
      error: (error) => {
        console.error('API Error:', error);
        this.toastr.error(error.error?.Message || 'Failed to send back application');
        this.dialogRef.close(false);
      }
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
